import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Box, IconButton, useTheme } from "@mui/material";
import {
  gridPageCountSelector,
  gridRowCountSelector,
  gridPageSizeSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";

export interface CustomPaginationSlotProps {
  page?: number;
  handlePageChange?: (page: number) => void;
}

const CustomPaginationSlot: React.FC<CustomPaginationSlotProps> = ({
  handlePageChange,
  page,
}) => {
  const apiRef = useGridApiContext();
  const theme = useTheme();
  const totalPages = useGridSelector(apiRef, gridPageCountSelector);
  const totalRows = useGridSelector(apiRef, gridRowCountSelector);
  const pageSize = useGridSelector(apiRef, gridPageSizeSelector);

  if (page === null || typeof page === "undefined") return null;

  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, totalRows);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginInlineEnd: "20px",
      }}
    >
      <Box sx={{ marginInline: "23px" }}>
        {startRow}-{endRow} of {totalRows}
      </Box>

      {/* Left Arrow */}
      <IconButton
        sx={{ color: theme.palette.text.primary, padding: "8px" }}
        onClick={() => handlePageChange?.(Math.max(page - 1, 0))}
        disabled={page === 0}
      >
        <ChevronLeft />
      </IconButton>

      {/* Right Arrow */}
      <IconButton
        sx={{ color: theme.palette.text.primary, padding: "8px" }}
        onClick={() => handlePageChange?.(Math.min(page + 1, totalPages - 1))}
        disabled={page >= totalPages - 1}
      >
        <ChevronRight />
      </IconButton>
    </Box>
  );
};

export default CustomPaginationSlot;
